module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/readable-stream/duplex-browser.js
// module id = ../../../../readable-stream/duplex-browser.js
// module chunks = 5